import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { RepresentanteFilterModule } from './filter';
import { RepresentantePipeSharedModule } from './pipes';
import { UsuarioSharedModule } from '../../usuario/usuario-shared.module';
import { CidadeModule } from '../../cidade';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TypeaheadRepresentanteComponent } from './typeahead';
import { RepresentantePopulaModalComponent } from './popula';

@NgModule({
    imports: [
        SharedModule,
        RepresentantePipeSharedModule,
        RepresentanteFilterModule,
        UsuarioSharedModule,
        CidadeModule,
        TypeaheadModule.forRoot()
    ],
    declarations: [
        TypeaheadRepresentanteComponent,
        RepresentantePopulaModalComponent
    ],
    exports: [
        SharedModule,
        RepresentantePipeSharedModule,
        TypeaheadRepresentanteComponent,
        RepresentantePopulaModalComponent
    ]
})
export class RepresentanteSharedModule { }
